export default __webpack_public_path__ + "static/media/inss.c9639697.jpg";